import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SUPPORTED_LANGUAGES } from 'utils/languages';

const LanguageRedirect = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Check if the current path already has a language code
    const hasLanguageCode = /^\/([a-z]{2})\//.test(currentPath);
    
    if (!hasLanguageCode) {
      // Determine the language to use
      let targetLanguage = 'de'; // Default to German
      
      // Get list of supported language codes
      const supportedCodes = SUPPORTED_LANGUAGES.map(lang => lang.code);
      
      // Try localStorage first
      const savedLang = localStorage.getItem('besper-language');
      if (savedLang && supportedCodes.includes(savedLang)) {
        targetLanguage = savedLang;
      } else {
        // Try browser language
        const browserLang = navigator.language.split('-')[0];
        if (supportedCodes.includes(browserLang)) {
          targetLanguage = browserLang;
        }
      }
      
      // Redirect to the language-specific URL
      const newPath = `/${targetLanguage}${currentPath}`;
      navigate(newPath, { replace: true });
    }
  }, [location.pathname, navigate]);

  // Only render children if we have a language code in the URL
  const hasLanguageCode = /^\/([a-z]{2})\//.test(location.pathname);
  
  if (!hasLanguageCode) {
    // Show loading while redirecting
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '16px'
      }}>
        Redirecting...
      </div>
    );
  }

  return children;
};

export default LanguageRedirect;
